import React, { useEffect } from 'react';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ChapterList } from '../components/ChapterList';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorks } from '../components/HowItWorks';
import { CredibilitySection } from '../components/CredibilitySection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-[#0A0A0A] text-gray-300 font-sans selection:bg-amber-500/30 selection:text-amber-200" data-id="element-179">
      <main data-id="element-180">
        <HeroSection data-id="element-181" />
        <ProblemSection data-id="element-182" />
        <SolutionSection data-id="element-183" />
        <ChapterList data-id="element-184" />
        <AudienceSection data-id="element-185" />
        <HowItWorks data-id="element-186" />
        <CredibilitySection data-id="element-187" />
        <CTASection data-id="element-188" />
      </main>

      <Footer data-id="element-189" />
    </div>;
}